import { render, staticRenderFns } from "./ReadOnlyInput.vue?vue&type=template&id=4bfdf81c&scoped=true&"
import script from "./ReadOnlyInput.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyInput.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyInput.vue?vue&type=style&index=0&id=4bfdf81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfdf81c",
  null
  
)

export default component.exports